var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"12","lg":"12","sm":"12"}},[_c('user-timesheet-daily-table',{attrs:{"id":_vm.id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }